// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-position-goal-scorer-table {
    background: var(--white-color);
}

table.tournament-position-goal-scorer-table {
    border-collapse: collapse;
    width: 100%;
    background: var(--white-color);
    border-radius: 8px;
    border: 2px solid var(--new-background-color);
}

.tournament-position-goal-scorer-table__team-name {
    display: flex;
    align-items: center;
    width: 100%;
}

.tournament-position-goal-scorer-table__table-header th {
    padding: var(--space) 0;
    text-align: left;    
}

.tournament-position-goal-scorer-table__table-header th:first-child {
    padding-left: 20px;
}

.tournament-position-goal-scorer-table__table-header th:last-child{
    padding-right: 20px;
}

.tournament-position-goal-scorer-table__table-body tr,
.tournament-position-goal-scorer-table__table-header {
    border-bottom: 1px solid var(--new-gray-background-color);
}

.tournament-position-goal-scorer-table__table-body tr:last-of-type {
    border-bottom: none;
}

.tournament-position-goal-scorer-table__table-body td {
    padding: var(--space-half) 0;
}

td.tournament-position-goal-scorer-table__team-name {
    padding-left: 20px;
}

.tournament-position-goal-scorer-table__table-body td:last-of-type {
    padding-right: 20px;
}

.tournament-position-goal-scorer-table__team-name .icon-ball {
    color: var( --white-color );
    font-size: var( --space-and-half );
    border-radius: 50%;
    padding: var( --space-quarter );
}

.tournament-position-goal-scorer-table__team-name img {
    width: 32px;
    height: 32px;
    border-radius: 50%;
}

.tournament-position-goal-scorer-table__container {
    background-color: var(--new-background-color);
    padding: 6px;
    border-radius:8px;
}

.tournament-position-goal-scorer-table__team-name img,
.tournament-position-goal-scorer-table__team-name span {
    margin: 0 var(--space);
}

.tournament-position-goal-scorer-table__vertical-line__best-third-team,
.tournament-position-goal-scorer-table__vertical-line__clasified-team,
.tournament-position-goal-scorer-table__vertical-line {
    height: 32px;
    width: 4px;
    border-radius: var(--space-half);
}

.tournament-position-goal-scorer-table__vertical-line__best-third-team {
    background-color: #FA7B17;
}

.tournament-position-goal-scorer-table__vertical-line__clasified-team {
    background-color: var(--new-green-color);
}

.tournament-position-goal-scorer-table__table-body .baloa-body-2 {
    width:  var(--space);
    position: relative;
    left: var(--space-half);
}

/* New styles */
.tournament-position-goal-scorer-table__accordion-item-group.MuiPaper-root.MuiAccordion-root {
    box-shadow: unset;
}

.tournament-position-goal-scorer-table__accordion-item-group.MuiPaper-root.MuiAccordion-root::before {
    height: 0;
}

/* .tournament-position-goal-scorer-table__accordion-item-group:last-of-type .tournament-position-goal-scorer-table__accordion-item-group__summary.MuiButtonBase-root.MuiAccordionSummary-root {
    margin-bottom: 0;
} */

.tournament-position-goal-scorer-table__accordion-item-group.MuiPaper-root.MuiAccordion-root.Mui-expanded {
    border: 1px solid var(--new-gray-background-color);
    border-radius: 5px;
    margin: 0;
    margin-bottom: 10px;
}

.tournament-position-goal-scorer-table__accordion-item-group .MuiAccordionDetails-root {
    padding: 8px;
}

.tournament-position-goal-scorer-table__accordion-item-group__summary.MuiButtonBase-root.MuiAccordionSummary-root {
    border-radius: 5px;
    border: 1px solid var(--new-gray-background-color);
    background: var(--white-color);
    margin-bottom: 10px;
    background: var(--new-light-gray-background-color);
}

.tournament-position-goal-scorer-table__accordion-item-group__summary .baloa-normal-medium {
    color: var(--primary-very-dark-color);
}

.tournament-position-goal-scorer-table__accordion-item-group__summary.MuiButtonBase-root.MuiAccordionSummary-root.Mui-expanded {
    border-radius: 5px 5px 0 0;
    margin-bottom: 0;
    border: 0;
    border-bottom: 1px solid var(--new-gray-background-color);
    background: var(--new-light-gray-background-color);
    min-height: unset;
}

.tournament-position-goal-scorer-table__accordion-item-group__summary .MuiAccordionSummary-content.Mui-expanded {
    margin: 12px 0;

}

.tournament-position-goal-scorer-table__table-header.skeleton {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px;
}

.tournament-position-goal-scorer-table__skeleton-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 20px;
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */
    

    .container-position-goal-scorer-table .col-left {
        padding: 0 12px 12px 12px;
        background: var(--new-background-color);
    }

    .tournament-position-goal-scorer-table__container{
        width: 100%;
        padding: 0;
        background-color: transparent;
    }

    table.tournament-position-goal-scorer-table {
        background: var(--white-color);
        border-radius: 0 0 5px 5px;
        padding: 0 12px;
        border: none;
    } 

    .tournament-position-goal-scorer-table__container .baloa-subtitle-1{
        background: var(--white-color);
        margin: 12px; 
        padding: 8px;
        border-radius: 5px;
    }

    .tournament-position-goal-scorer-table__team-name{
        width: 140px;
    }

    .tournament-position-goal-scorer-table__table-header th:first-child {
        padding-left: 10px;
    }

    .tournament-position-goal-scorer-table__table-header th:last-child {
        padding-right: 0;
    }

    .tournament-position-goal-scorer-table__table-body td:last-of-type {
        padding-right: 0;
    }

    td.tournament-position-goal-scorer-table__team-name {
        padding-left: 0;
    }

    /* New styles */

    .tournament-position-goal-scorer-table__accordion-item-group.MuiPaper-root.MuiAccordion-root {
        background: var(--new-background-color);
    }

    .tournament-position-goal-scorer-table__accordion-item-group.MuiPaper-root.MuiAccordion-root.Mui-expanded {
        margin: 0 0 12px 0;
    }

    .tournament-position-goal-scorer-table__accordion-item-group .MuiAccordionDetails-root {
        padding: 0;
    }

    .tournament-position-goal-scorer-table__accordion-item-group .MuiCollapse-root {
        border-bottom: 0;
    }

    /* .tournament-position-goal-scorer-table__accordion-item-group .tournament-position-goal-scorer-table__date-by-group {
        border-radius: 0;
        border: none;
    }

    .tournament-position-goal-scorer-table__accordion-item-group .tournament-position-goal-scorer-table__match-detail-container {
        border: none;
        border-bottom: 1px solid var(--new-gray-background-color);
    }

    .tournament-position-goal-scorer-table__accordion-item-group .tournament-position-goal-scorer-table__match-detail-container:last-of-type {
        border-bottom: none;
    } */

    .tournament-position-goal-scorer-table__accordion-item-group__summary.MuiButtonBase-root.MuiAccordionSummary-root {
        min-height: unset;
        margin-bottom: 12px;
    }
    
    .tournament-position-goal-scorer-table__accordion-item-group__summary.MuiButtonBase-root.MuiAccordionSummary-root.Mui-expanded {
        min-height: unset;
    }

    .tournament-position-goal-scorer-table__accordion-item-group__summary .MuiAccordionSummary-content.Mui-expanded {
        margin: 8px 0;
    }

    .tournament-position-goal-scorer-table__free-title {
        padding: 8px;
        border-radius: 4px 4px 0px 0px;
        border-bottom: 1px solid var(--new-gray-background-color);
        background: var(--white-color);
    }

    .tournament-position-goal-scorer-table__free-title .baloa-names {
        color: var(--primary-very-dark-color);
    }

    .tournament-position-goal-scorer-table__table-header .baloa-table {
        color: var(--basic-gray-color);
    }
}
`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/tournament-position-goal-scorer-table/TournamentPositionGoalScorerTableComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,8BAA8B;IAC9B,kBAAkB;IAClB,6CAA6C;AACjD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,yDAAyD;AAC7D;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,kCAAkC;IAClC,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,6CAA6C;IAC7C,YAAY;IACZ,iBAAiB;AACrB;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;;;IAGI,YAAY;IACZ,UAAU;IACV,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA,eAAe;AACf;IACI,iBAAiB;AACrB;;AAEA;IACI,SAAS;AACb;;AAEA;;GAEG;;AAEH;IACI,kDAAkD;IAClD,kBAAkB;IAClB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,kDAAkD;IAClD,8BAA8B;IAC9B,mBAAmB;IACnB,kDAAkD;AACtD;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,SAAS;IACT,yDAAyD;IACzD,kDAAkD;IAClD,iBAAiB;AACrB;;AAEA;IACI,cAAc;;AAElB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA,yCAAyC,4BAA4B;;;IAGjE;QACI,yBAAyB;QACzB,uCAAuC;IAC3C;;IAEA;QACI,WAAW;QACX,UAAU;QACV,6BAA6B;IACjC;;IAEA;QACI,8BAA8B;QAC9B,0BAA0B;QAC1B,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,8BAA8B;QAC9B,YAAY;QACZ,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA,eAAe;;IAEf;QACI,uCAAuC;IAC3C;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,gBAAgB;IACpB;;IAEA;;;;;;;;;;;;OAYG;;IAEH;QACI,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,8BAA8B;QAC9B,yDAAyD;QACzD,8BAA8B;IAClC;;IAEA;QACI,qCAAqC;IACzC;;IAEA;QACI,8BAA8B;IAClC;AACJ","sourcesContent":[".container-position-goal-scorer-table {\n    background: var(--white-color);\n}\n\ntable.tournament-position-goal-scorer-table {\n    border-collapse: collapse;\n    width: 100%;\n    background: var(--white-color);\n    border-radius: 8px;\n    border: 2px solid var(--new-background-color);\n}\n\n.tournament-position-goal-scorer-table__team-name {\n    display: flex;\n    align-items: center;\n    width: 100%;\n}\n\n.tournament-position-goal-scorer-table__table-header th {\n    padding: var(--space) 0;\n    text-align: left;    \n}\n\n.tournament-position-goal-scorer-table__table-header th:first-child {\n    padding-left: 20px;\n}\n\n.tournament-position-goal-scorer-table__table-header th:last-child{\n    padding-right: 20px;\n}\n\n.tournament-position-goal-scorer-table__table-body tr,\n.tournament-position-goal-scorer-table__table-header {\n    border-bottom: 1px solid var(--new-gray-background-color);\n}\n\n.tournament-position-goal-scorer-table__table-body tr:last-of-type {\n    border-bottom: none;\n}\n\n.tournament-position-goal-scorer-table__table-body td {\n    padding: var(--space-half) 0;\n}\n\ntd.tournament-position-goal-scorer-table__team-name {\n    padding-left: 20px;\n}\n\n.tournament-position-goal-scorer-table__table-body td:last-of-type {\n    padding-right: 20px;\n}\n\n.tournament-position-goal-scorer-table__team-name .icon-ball {\n    color: var( --white-color );\n    font-size: var( --space-and-half );\n    border-radius: 50%;\n    padding: var( --space-quarter );\n}\n\n.tournament-position-goal-scorer-table__team-name img {\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n}\n\n.tournament-position-goal-scorer-table__container {\n    background-color: var(--new-background-color);\n    padding: 6px;\n    border-radius:8px;\n}\n\n.tournament-position-goal-scorer-table__team-name img,\n.tournament-position-goal-scorer-table__team-name span {\n    margin: 0 var(--space);\n}\n\n.tournament-position-goal-scorer-table__vertical-line__best-third-team,\n.tournament-position-goal-scorer-table__vertical-line__clasified-team,\n.tournament-position-goal-scorer-table__vertical-line {\n    height: 32px;\n    width: 4px;\n    border-radius: var(--space-half);\n}\n\n.tournament-position-goal-scorer-table__vertical-line__best-third-team {\n    background-color: #FA7B17;\n}\n\n.tournament-position-goal-scorer-table__vertical-line__clasified-team {\n    background-color: var(--new-green-color);\n}\n\n.tournament-position-goal-scorer-table__table-body .baloa-body-2 {\n    width:  var(--space);\n    position: relative;\n    left: var(--space-half);\n}\n\n/* New styles */\n.tournament-position-goal-scorer-table__accordion-item-group.MuiPaper-root.MuiAccordion-root {\n    box-shadow: unset;\n}\n\n.tournament-position-goal-scorer-table__accordion-item-group.MuiPaper-root.MuiAccordion-root::before {\n    height: 0;\n}\n\n/* .tournament-position-goal-scorer-table__accordion-item-group:last-of-type .tournament-position-goal-scorer-table__accordion-item-group__summary.MuiButtonBase-root.MuiAccordionSummary-root {\n    margin-bottom: 0;\n} */\n\n.tournament-position-goal-scorer-table__accordion-item-group.MuiPaper-root.MuiAccordion-root.Mui-expanded {\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 5px;\n    margin: 0;\n    margin-bottom: 10px;\n}\n\n.tournament-position-goal-scorer-table__accordion-item-group .MuiAccordionDetails-root {\n    padding: 8px;\n}\n\n.tournament-position-goal-scorer-table__accordion-item-group__summary.MuiButtonBase-root.MuiAccordionSummary-root {\n    border-radius: 5px;\n    border: 1px solid var(--new-gray-background-color);\n    background: var(--white-color);\n    margin-bottom: 10px;\n    background: var(--new-light-gray-background-color);\n}\n\n.tournament-position-goal-scorer-table__accordion-item-group__summary .baloa-normal-medium {\n    color: var(--primary-very-dark-color);\n}\n\n.tournament-position-goal-scorer-table__accordion-item-group__summary.MuiButtonBase-root.MuiAccordionSummary-root.Mui-expanded {\n    border-radius: 5px 5px 0 0;\n    margin-bottom: 0;\n    border: 0;\n    border-bottom: 1px solid var(--new-gray-background-color);\n    background: var(--new-light-gray-background-color);\n    min-height: unset;\n}\n\n.tournament-position-goal-scorer-table__accordion-item-group__summary .MuiAccordionSummary-content.Mui-expanded {\n    margin: 12px 0;\n\n}\n\n.tournament-position-goal-scorer-table__table-header.skeleton {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 15px;\n}\n\n.tournament-position-goal-scorer-table__skeleton-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 10px 20px;\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n    \n\n    .container-position-goal-scorer-table .col-left {\n        padding: 0 12px 12px 12px;\n        background: var(--new-background-color);\n    }\n\n    .tournament-position-goal-scorer-table__container{\n        width: 100%;\n        padding: 0;\n        background-color: transparent;\n    }\n\n    table.tournament-position-goal-scorer-table {\n        background: var(--white-color);\n        border-radius: 0 0 5px 5px;\n        padding: 0 12px;\n        border: none;\n    } \n\n    .tournament-position-goal-scorer-table__container .baloa-subtitle-1{\n        background: var(--white-color);\n        margin: 12px; \n        padding: 8px;\n        border-radius: 5px;\n    }\n\n    .tournament-position-goal-scorer-table__team-name{\n        width: 140px;\n    }\n\n    .tournament-position-goal-scorer-table__table-header th:first-child {\n        padding-left: 10px;\n    }\n\n    .tournament-position-goal-scorer-table__table-header th:last-child {\n        padding-right: 0;\n    }\n\n    .tournament-position-goal-scorer-table__table-body td:last-of-type {\n        padding-right: 0;\n    }\n\n    td.tournament-position-goal-scorer-table__team-name {\n        padding-left: 0;\n    }\n\n    /* New styles */\n\n    .tournament-position-goal-scorer-table__accordion-item-group.MuiPaper-root.MuiAccordion-root {\n        background: var(--new-background-color);\n    }\n\n    .tournament-position-goal-scorer-table__accordion-item-group.MuiPaper-root.MuiAccordion-root.Mui-expanded {\n        margin: 0 0 12px 0;\n    }\n\n    .tournament-position-goal-scorer-table__accordion-item-group .MuiAccordionDetails-root {\n        padding: 0;\n    }\n\n    .tournament-position-goal-scorer-table__accordion-item-group .MuiCollapse-root {\n        border-bottom: 0;\n    }\n\n    /* .tournament-position-goal-scorer-table__accordion-item-group .tournament-position-goal-scorer-table__date-by-group {\n        border-radius: 0;\n        border: none;\n    }\n\n    .tournament-position-goal-scorer-table__accordion-item-group .tournament-position-goal-scorer-table__match-detail-container {\n        border: none;\n        border-bottom: 1px solid var(--new-gray-background-color);\n    }\n\n    .tournament-position-goal-scorer-table__accordion-item-group .tournament-position-goal-scorer-table__match-detail-container:last-of-type {\n        border-bottom: none;\n    } */\n\n    .tournament-position-goal-scorer-table__accordion-item-group__summary.MuiButtonBase-root.MuiAccordionSummary-root {\n        min-height: unset;\n        margin-bottom: 12px;\n    }\n    \n    .tournament-position-goal-scorer-table__accordion-item-group__summary.MuiButtonBase-root.MuiAccordionSummary-root.Mui-expanded {\n        min-height: unset;\n    }\n\n    .tournament-position-goal-scorer-table__accordion-item-group__summary .MuiAccordionSummary-content.Mui-expanded {\n        margin: 8px 0;\n    }\n\n    .tournament-position-goal-scorer-table__free-title {\n        padding: 8px;\n        border-radius: 4px 4px 0px 0px;\n        border-bottom: 1px solid var(--new-gray-background-color);\n        background: var(--white-color);\n    }\n\n    .tournament-position-goal-scorer-table__free-title .baloa-names {\n        color: var(--primary-very-dark-color);\n    }\n\n    .tournament-position-goal-scorer-table__table-header .baloa-table {\n        color: var(--basic-gray-color);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
